(function(){
'use strict';

scCampaignSearchModel.$inject = ["scResourceSearchModel"];
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function scCampaignSearchModel(scResourceSearchModel) {
  return function (_scResourceSearchMode) {
    _inherits(CampaignSearchModel, _scResourceSearchMode);

    function CampaignSearchModel(fields, queryParams) {
      _classCallCheck(this, CampaignSearchModel);

      return _possibleConstructorReturn(this, (CampaignSearchModel.__proto__ || Object.getPrototypeOf(CampaignSearchModel)).call(this, 'campaigns', fields, queryParams));
    }

    /**
     * {@inheritdoc}
     */


    _createClass(CampaignSearchModel, [{
      key: 'getReadableTypeName',
      value: function getReadableTypeName() {
        return 'campaigns';
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getName',
      value: function getName(resource) {
        return SC.public ? resource.name : resource.internal_name || resource.name;
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getDescription',
      value: function getDescription(resource) {
        return resource.description.replace(/<\/?(.*?)>/g, '');
      }
    }]);

    return CampaignSearchModel;
  }(scResourceSearchModel);
}

angular.module('classy').factory('scCampaignSearchModel', scCampaignSearchModel);
})();